export default __webpack_public_path__ + "static/media/wismob1.c32ffdd0.jpg";